export default "/images/artist3.png?a483f3eebc983f2d13da35b61a0e9cc0";